import request from '@/utils/httpRequest'

export default class InspectionRectifyService {

    queryById(id) {
        return request({
            url: '/infacy/wuyeInfacyMain/queryById',
            method: 'get',
            params: {id}
        })
    }

    saveProInsId(data){
        return request({
            url: '/infacy/wuyeInfacyMain/updateProcess',
            method: 'post',
            data: data
        })
    }
}